import { renderSlot as _renderSlot } from "vue"

export function render(_ctx, _cache) {
  return _renderSlot(_ctx.$slots, "default")
}